interface ApiOptions<D> {
	data?: D
	isCustomNamespace?: boolean
}

interface ApiGetOptions<R> extends ApiOptions<R> {}

interface ApiPostOptions<R> extends ApiOptions<R> {}

interface ApiResponse<T> extends Response {
	data: T
}

interface ApiError extends Error {}

type ApiNamespaces = Record<'standard' | 'custom' | string, string>

interface IApi {
	base: string
	namespaces: ApiNamespaces
	get<T = unknown, R = ApiResponse<T>>(url: string, options?: ApiGetOptions<T>): Promise<R>
	post<T = unknown, R = ApiResponse<T>>(url: string, options?: ApiPostOptions<T>): Promise<R>
}

const API = function API(base?: string, namespaces?: ApiNamespaces): IApi {
	return {
		base: base ?? import.meta.env.VITE_NETLIFY_API ?? '',
		namespaces: {
			standard: import.meta.env.VITE_API_NAMESPACE ?? '',
			custom: import.meta.env.VITE_API_CUSTOM_NAMESPACE ?? '',
			...namespaces,
		},

		get<T = unknown, R = ApiResponse<T>>(url: string, options?: ApiGetOptions<T>): Promise<R> {
			const name = options?.isCustomNamespace ? this.namespaces.custom : this.namespaces.standard
			console.log('GET name: ', name)

			return fetch(this.base + name + url, {
				method: 'GET',
				// body: options.data,
			})
				.then((response) => {
					return response.json()
				})
				.then((json) => {
					return Promise.resolve(json as R)
				})
				.catch((error: ApiError) => {
					return Promise.reject(error)
				})
		},

		post<T = unknown, R = ApiResponse<T>>(url: string, options?: ApiPostOptions<T>): Promise<R> {
			const name = options?.isCustomNamespace ? this.namespaces.custom : this.namespaces.standard
			console.log('POST name: ', name)

			const req: RequestInit = {
				method: 'POST',
				body: JSON.stringify({
					...options?.data,
				}),
			}

			return fetch(this.base + name + url, req)
				.then((response) => {
					return response.json()
				})
				.then((json) => {
					return Promise.resolve(json as R)
				})
				.catch((error: ApiError) => {
					return Promise.reject(error)
				})
		},
	} satisfies IApi
}

export default API
